import { COMPONENTS } from '../../../components/components.registry';
import { CloseConfig } from '../../../models';

export const DEFAULT_CLOSE_CONFIG: CloseConfig = {
  components: {
    close: COMPONENTS.PURE.DefaultClose,
    icon: COMPONENTS.PURE.CrossIcon
  }
};
